import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight, FileText } from 'lucide-react';
import { useSeo } from '../hooks/useSeo';
import cities from '../content/cities.json';

const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } } };

const META = {
  title: 'Distributore K-Beauty in Tutta Italia | Cosmetici Coreani e Rinforzanti Unghie B2B',
  description: 'Distributore K-Beauty B2B con consegne in tutta Italia: Roma, Milano, Napoli, Torino, Bologna, Firenze, Bari, Palermo. Cosmetici coreani e rinforzanti unghie Trind per farmacie e profumerie.'
};

export default function CityHubPage() {
  useSeo(META, '/distributore-k-beauty');
  return (
    <main className="pt-20" data-testid="city-hub-page">
      <section className="section-spacing bg-[#F9F9F9]">
        <motion.div className="container-luxury" initial="hidden" animate="visible" variants={fadeInUp}>
          <div className="max-w-4xl">
            <span className="label-style text-gold mb-4 block">Consegne in tutta Italia</span>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl mb-6" data-testid="city-hub-h1">Distributore K-Beauty in Tutta Italia per Farmacie e Profumerie</h1>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">Enhancements srl distribuisce cosmetici coreani K-Beauty e rinforzanti unghie Trind a farmacie, parafarmacie, profumerie, centri estetici ed e-commerce in tutte le regioni italiane, dal Nord alle isole. Dalla nostra sede di Formello (Roma) spediamo ovunque con consegne rapide e tracciate.</p>
            <Link to="/richiesta-listino" className="btn-primary inline-flex items-center gap-2" data-testid="city-hub-pricelist-cta"><FileText size={16} /> Richiedi il listino B2B</Link>
          </div>
        </motion.div>
      </section>
      <section className="section-spacing">
        <div className="container-luxury">
          <h2 className="font-heading text-3xl sm:text-4xl mb-10">Le principali città servite</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {cities.map((c) => (
              <Link key={c.slug} to={`/distributore-k-beauty/${c.slug}`} className="group p-8 bg-[#F9F9F9] border-t-2 border-[#C5A059] hover:shadow-md transition-shadow" data-testid={`city-hub-card-${c.slug}`}>
                <p className="text-xs uppercase tracking-wider text-gray-500 mb-2 flex items-center gap-2"><MapPin size={12} /> {c.region}</p>
                <h3 className="font-heading text-2xl mb-3">Distributore K-Beauty {c.name}</h3>
                <p className="text-sm text-gray-600 mb-4">Consegna in {c.delivery} · {c.provinces.slice(0, 3).join(', ')} e provincia</p>
                <span className="text-xs uppercase tracking-wider text-gold inline-flex items-center gap-2">Scopri <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" /></span>
              </Link>
            ))}
          </div>
          <p className="text-gray-600 mt-12 max-w-3xl leading-relaxed">La tua città non è in elenco? Nessun problema: serviamo rivenditori in tutta Italia, comprese Veneto, Liguria, Marche, Abruzzo, Umbria, Calabria, Sardegna e Trentino-Alto Adige. Scrivici e ti invieremo listino e tempi di consegna per la tua zona.</p>
        </div>
      </section>
    </main>
  );
}
